export default __webpack_public_path__ + "9adf0bbeb35ab2e2eb626d1dd7a96375.svg";